import { FC } from "react"
import { Loader2 } from "lucide-react"
import { PricingProfile, BBColumnDef } from "../../../../types"
import Table from "../../table"
import LabelCell from "./cells/Label"
import ActionCell from "../../rates/table/cells/Action"

interface Props {
  data: PricingProfile[]
  isLoading: boolean
  hasAction?: boolean
  isFullCellClickable?: boolean
  onClickItem?: (id: string) => void
}

const PricingProfilesTable: FC<Props> = ({
  data,
  isLoading,
  hasAction = false,
  isFullCellClickable,
  onClickItem
}) => {
  const columns: BBColumnDef<PricingProfile>[] = [
    {
      id: "label",
      header: "Label",
      footer: props => props.column.id,
      cell: props => (
        <LabelCell
          value={props.row}
          hasAction={isFullCellClickable}
          onClick={onClickItem}
        />
      )
    }
  ]

  if (hasAction)
    columns.push({
      id: "action",
      header: "Action",
      footer: props => props.column.id,
      cell: props => (
        <ActionCell
          value={props.row.original.pricing_profile_id.toString()}
          isFullCellClickable={isFullCellClickable}
          onClick={onClickItem!}
        />
      )
    })
  return (
    <div className="h-full flex flex-col">
      <div className="flex-1">
        {isLoading ? (
          <div className="h-full flex items-center justify-center">
            <Loader2
              className={`animate-spin h-16 w-16 text-primary-alt-400`}
              aria-hidden="true"
            />
          </div>
        ) : (
          <div className="bg-white">
            <Table
              data={data}
              columns={columns}
              viewType="table"
              searchBarVisible={false}
              noHeader
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default PricingProfilesTable
